import type { FaireProductEntity } from "../../entity_types/product";

export const p_kjwfdfzbjt: FaireProductEntity = {
  token: "p_kjwfdfzbjt",
  type: "product",
  name: "Natural Blue Lace Agate Tumble Loose Stone Chips",
  brandToken: "b_t9ve76j393",
  brandName: "CaNatureLover",
  imageUrl:
    "https://cdn.faire.com/fastly/32ed61dacc5faca05e764ba280f198100340d8eb163da830edf8e34ca62c4946.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/480dad58def91be66b8e32b6cf0fb6e8468b4ff0f3d0b5b19df88e232d901e19.jpeg",
    "https://cdn.faire.com/fastly/0f612dfd9ffb245b094a79851c4f14e0ec0e1f99eba929f96403fb06f4885b8d.jpeg",
    "https://cdn.faire.com/fastly/b6ab53d44cdcbe7fc585968aafa72f04c90086f717e37ef830605a7f773a30ab.jpeg",
    "https://cdn.faire.com/fastly/a690a910d07fa4f788cdcbf749e26dba59a9fe32067bc7fbaab44bb89d7e8fbe.jpeg",
    "https://cdn.faire.com/fastly/cc999b24d051e39334d428dd324250ee7158d564da0186b861508ad0bf0c7596.jpeg",
    "https://cdn.faire.com/fastly/757993efc8b3e68f80c5c0238f2a8995c6d7b7190907b7795216d5c8c5202e67.jpeg",
    "https://cdn.faire.com/fastly/451ae2a022511f5e53a7d120540cd5a819669873caf11b5f01768c99d8d3b013.jpeg",
    "https://cdn.faire.com/fastly/646ae3f80af1c8d45fd3af187d154e46b7cf97e743caaa579a53c9b5e6573206.jpeg",
    "https://cdn.faire.com/fastly/cd602b95eaa13d9c6819f970e7f214697c10230740160115812c3dcde61f9d15.jpeg",
  ],
  priceDollars: 2.5,
  description:
    "\nITEM DETAILS -\n\nsizes may vary because its natural gemstones made by nature sizes are around 0.25-0.50 inches (5-8 mm)\n\nBelieved to have formed in the cretaceous period roughly 65 to 90 million years ago, crazy lace agate is a banded chalcedony or microcrystalline quartz mineral infused with iron and aluminum. It's a unique stone in that it's often brightly colored and filled with ornate, intricate patterns.\n\n~ Healing ~\n Hope\n Unity\n Cleansing\n Purification\n Promptness\n Calming\n Harmony\n Protection\n Optimism\n Positive thinking\n Joy\n Truth\n Appreciation for nature\n Smooth energy flow\n\nBlue Lace Agate helps to strengthen and accelerate the repair of bones, thyroid deficiencies, throat and lymph infections.",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:00.814Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
